// import { scope } from '#components/generics/js/selectors/scope.js'
import manager from '@mailobj-browser/front/js/contracts/manager.js'
import preventDefault
  from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import { tapUp } from '@mailobj-browser/front/js/events/listeners/builtins/tap.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import once from '@mailobj-browser/front/js/events/options/once.js'
import keyDown from '@mailobj-browser/front/js/events/types/keyDown.js'
import load from '@mailobj-browser/front/js/events/types/load.js'
import resize from '@mailobj-browser/front/js/events/types/resize.js'
import touchStart from '@mailobj-browser/front/js/events/types/touchStart.js'
import touchMove from '@mailobj-browser/front/js/events/types/touchMove.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import element from '@mailobj-browser/front/js/tree/element.js'
import prepend from '@mailobj-browser/front/js/tree/prepend.js'
import append from '@mailobj-browser/front/js/tree/append.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'
import rendered from '@mailobj-browser/front/js/tree/rendered.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { elements } from '#components/generics/js/styles.js'
import wait from '@mailobj-browser/front/js/utils/wait.js'
import globals from '#utilities/js/ea/globals.js'
import { format } from '#utilities/js/hotkey/hotkey.js'
import * as printButton from '#components/generics/js/print/button.js'
import { onTapUp } from '#components/generics/js/selectors/anchor.js'
import skin from '#utilities/js/ea/skin.js'
import { remove } from '@mailobj-browser/front/js/tree/tree.js'

const { parseFloat } = Number
const containers = new WeakMap()
const iframes = new WeakMap()
let currentScale = 1
let initialScale
let initialDistance = 1
let touch1
let touch2

const onLoad = object(listener, {
  type: load,
  passive,
  once,
  task: async (
    iframe
  ) => {
    const { contentWindow, contentDocument, ownerDocument } = iframe
    const { defaultView } = ownerDocument

    addIframeContentBeforeAfter(iframe)
    resizing(iframe)

    iframes.set(contentWindow, iframe)
    onResize.listen(defaultView)
    onTouchStart.listen(contentWindow)
    onKeyDown.listen(ownerDocument)
    onKeyDown.listen(contentDocument)

    for (const anchor of all('a[href]', contentDocument)) {
      onTapUpAnchor.listen(anchor)
    }

    queueMicrotask(async () => {
      await removed(iframe)

      if (iframes.get(contentWindow) === iframe) {
        iframes.delete(contentWindow)
        containers.delete(ownerDocument)
      }
    })
  }
})

// @todo Remettre ce code quand on aura sur la modal "Ne plus demander" + gestion dans les prefs pour
// réafficher cette modal
const onTapUpAnchor = object(tapUp, {
  hooks: array([
    preventDefault,
  ]),
  task: async (anchor, event) => {
    // const { ownerDocument, href } = anchor
    // const { defaultView } = ownerDocument
    // const { top } = defaultView
    // const iframe = iframes.get(defaultView)
    // const scopeJson = scope(iframe)
    // const { confirm } = scopeJson
    // const { title, text } = confirm
    //
    // /*
    // * @todo fb Supprimer ce script quand gestion confirm sur liens externes sera générique
    // * http://10.9.0.11:3000/mailobject/mailobject/issues/727
    // */
    // if (new URL(top.location.href).hostname !== new URL(href).hostname) {
    if (['app'].includes(skin)) {
      anchor.setAttribute('target', 'popup')
    } else {
      anchor.setAttribute('target', '_blank')
    }
    //   anchor.setAttribute('data-confirm', JSON.stringify({
    //     title: title,
    //     text: text + ' ' + href,
    //   }))
    // }

    onTapUp.task(anchor, event)
  }
})

const resizing = iframe => {
  const { contentDocument, style, dataset } = iframe

  if (!contentDocument) {
    return
  }

  const { documentElement, body } = contentDocument
  const { contentHeight } = dataset
  const { length: imgLength } = all('body > img', documentElement)

  if (contentHeight) {
    const {
      marginTop,
      marginBottom
    } = getComputedStyle(body)
    const {
      borderTopWidth,
      borderBottomWidth
    } = getComputedStyle(iframe)
    let height = Math.max(
      Math.max(
        body.clientHeight,
        body.scrollHeight
      ),
      Math.max(
        documentElement.clientHeight,
        documentElement.scrollHeight
      )
    )

    height += (parseFloat(marginTop) || 0) + (parseFloat(marginBottom) || 0)
    height += (parseFloat(borderTopWidth) || 0) + (parseFloat(borderBottomWidth) || 0)
    height = Math.ceil(height)
    style.setProperty('--ea_iframe_height', `${height + 1}px`) // +1px to fix scroll bug
  } else if (imgLength === 1) {
    const firstElement = one('body > *:first-child', documentElement)
    const { naturalWidth, naturalHeight } = firstElement
    const iframeContainer = closest(`.${elements.iframe}`, iframe)

    if (naturalWidth > iframeContainer.clientWidth) {
      style.setProperty('--ea_iframe_width', `${iframeContainer.clientWidth}px`)
      style.setProperty('--ea_iframe_height', `${(iframeContainer.clientWidth * naturalHeight / naturalWidth) + 1}px`) // +1px to fix scroll bug
    } else {
      style.setProperty('--ea_iframe_width', `${naturalWidth}px`)
      style.setProperty('--ea_iframe_height', `${naturalHeight + 1}px`) // +1px to fix scroll bug
    }
  }

  if (typeof globals.ea_screen_adjust_main === 'function') { // Pour le designsystem
    globals.ea_screen_adjust_main() // A supprimer quand ancienne structure sera supprimée
  }
}

const create = async (iframe) => {
  const { dataset, style: iframeStyle } = iframe
  const {
    head: iframeHeadTags,
    css,
    dir,
    spacing,
    skin,
    theme,
    lang
  } = dataset
  const iframeHeadTagsParse = JSON.parse(iframeHeadTags)
  const iframeContainer = closest(`.${elements.iframe}`, iframe)
  const head = element(iframe, 'head')
  const style = element(iframe, 'style', {}, css)
  const baseTag = element(iframe, 'base')
  const titleTag = element(iframe, 'title')
  const body = element(iframe, 'body')
  const { content: templateBodyContent } = one('template:first-of-type', iframeContainer)

  if (iframeHeadTagsParse.title) {
    titleTag.innerHTML = iframeHeadTagsParse.title
  } else {
    titleTag.innerHTML = '-'
  }

  iframeHeadTagsParse.meta?.forEach(meta => {
    const metaTag = element(iframe, 'meta')
    let hasMetaTag = false

    if (meta.charset) {
      metaTag.setAttribute('charset', meta.charset)
      hasMetaTag = true
    } else if (meta.name === 'viewport') {
      metaTag.setAttribute('name', meta.name)
      metaTag.setAttribute('content', meta.content)
      hasMetaTag = true
    }

    if (hasMetaTag) {
      append(head, metaTag)
    }
  })

  if (iframeHeadTagsParse.base) {
    if (iframeHeadTagsParse.base?.target) {
      baseTag.setAttribute('target', iframeHeadTagsParse.base.target)
    }

    if (iframeHeadTagsParse.base?.href) {
      baseTag.setAttribute('href', iframeHeadTagsParse.base.href)
    }

    append(head, baseTag)
  }

  append(head, titleTag)
  append(head, style)

  if (templateBodyContent) {
    await manager.fragment(templateBodyContent.cloneNode(true))

    append(body, templateBodyContent)
  }

  for (const image of all('img[src]', body)) {
    const linkPreload = element(iframe, 'link', {
      'rel': 'preload',
      'href': image.src,
      'as': 'image'
    })
    const img = new Image()
    const iframeHeight = getComputedStyle(iframe).getPropertyValue('--ea_iframe_height') === 'auto' ? 0 : parseFloat(getComputedStyle(iframe).getPropertyValue('--ea_iframe_height'))

    append(head, linkPreload)

    img.src = image.src

    await loadImageAndGetDimensions(img)

    iframeStyle.setProperty('--ea_iframe_height', `${iframeHeight + img.naturalHeight}px`)
  }

  return `<!DOCTYPE html>
       <html
         dir="${dir}"
         lang="${lang}"
         data-spacing="${spacing}"
         data-skin="${skin}"
         data-theme="${theme}"
       >
         ${head.outerHTML}
         ${body.outerHTML}
       </html>`
}

const loadImageAndGetDimensions = async (image) => {
  queueMicrotask(async () => {
    // Wait for the image to load or fail
    await new Promise(resolve => {
      if (image.complete) {
        resolve()
      } else {
        image.addEventListener('load', resolve)
        image.addEventListener('error', resolve)
      }

      remove(image)
    })
  })
}

const addIframeContentBeforeAfter = iframe => {
  queueMicrotask(async () => {
    const { dataset, contentDocument } = iframe
    const { cssHref } = dataset

    if (cssHref) {
      const { head } = contentDocument
      const style = one('style', head)

      //@todo ça serait bien de l'avoir en cache pour éviter de le récupérer à chaque rechargement de mail
      try {
        const response = await fetch(cssHref)

        if (!response.ok) {
          throw new Error(`Status error, cannot load stylesheet: ${response.status}`)
        }

        const cssContent = await response.text()

        prepend(style, cssContent)
        resizing(iframe)
        addTemplateContent(iframe)
      } catch (error) {
        console.error('Css loading error :', error)
      }
    } else {
      addTemplateContent(iframe)
    }
  })
}

const addTemplateContent = iframe => {
  const { contentDocument } = iframe
  const iframeContainer = closest(`.${elements.iframe}`, iframe)
  const { content: templateContent } = one(`template:last-of-type`, iframeContainer)

  if (templateContent) {
    if (!contentDocument) {
      return
    }

    const { body } = contentDocument
    const insertBefore = one('[data-iframe-insert-before]', templateContent)
    const insertAfter = one('[data-iframe-insert-after]', templateContent)

    if (insertBefore) {
      prepend(body, insertBefore.cloneNode(true))
    }

    if (insertAfter) {
      append(body, insertAfter.cloneNode(true))
    }

    resizing(iframe)
  }
}

const rewrite = iframe => {
  queueMicrotask(async () => {
    const { contentDocument, dataset } = iframe
    const { designMode } = dataset

    if (designMode === 'on') {
      contentDocument.designMode = 'on'
    }

    iframe.srcdoc = await create(iframe)
    onLoad.listen(iframe)
  })
}

const onResize = object(listener, {
  type: resize,
  once,
  passive,
  async task (defaultView) {
    await wait(150)
    const { document } = defaultView
    const nestedContainers = containers.get(document)

    if (nestedContainers) {
      for (const container of nestedContainers) {
        const iframe = one('iframe', container)

        resizing(iframe)
        this.listen(defaultView)
      }
    }
  }
})

const onTouchStart = object(listener, {
  type: touchStart,
  task: (contentWindow, { touches }) => {
    if (touches.length === 2) {
      touch1 = touches[0]
      touch2 = touches[1]

      if (touch1 && touch2) {
        initialDistance = Math.hypot(
          touch1.clientX - touch2.clientX,
          touch1.clientY - touch2.clientY
        )
        initialScale = currentScale
      }

      onTouchMove.listen(contentWindow)
    }
  }
})

const onTouchMove = object(listener, {
  type: touchMove,
  task: (contentWindow, { touches: currentTouches }) => {
    requestAnimationFrame(() => {
      const currentTouch1 = currentTouches[0]
      const currentTouch2 = currentTouches[1]

      if (currentTouch1 && currentTouch2) {
        const currentDistance = Math.hypot(
          currentTouch1.clientX - currentTouch2.clientX,
          currentTouch1.clientY - currentTouch2.clientY
        )
        const { document } = contentWindow
        const { body } = document
        const scaleRatio = currentDistance / initialDistance

        // Min/max zoom value
        currentScale = Math.min(Math.max(initialScale * scaleRatio, 0.5), 3)
        body.style.transform = `scale(${currentScale})`
        body.style.transformOrigin = '0 0' // iOs
      }
    })
  }
})

const onKeyDown = object(listener, {
  type: keyDown,
  task: (
    document,
    event
  ) => {
    const key = format(event)
    let button = one('[data-contract~="print.button"]', document)

    if (key === 'Control+p') {
      preventDefault(event)

      if (!button) {
        const { defaultView } = document
        const { top } = defaultView
        const { document: topDocument } = top

        button = one('[data-contract~="print.button"]', topDocument)
      }

      if (button) {
        printButton.onClick.task(button)
      }
    }
  }
})

export default iframeContainer => {
  queueMicrotask(async () => {
    const { ownerDocument } = iframeContainer
    const { body } = ownerDocument

    await rendered(one('iframe', iframeContainer), body)

    const iframe = one('iframe', iframeContainer)

    if (!containers.has(ownerDocument)) {
      containers.set(ownerDocument, new Set())
    }

    containers.get(ownerDocument).add(iframeContainer)
    rewrite(iframe)
  })
}
